<form [formGroup]="form">
    <mat-slide-toggle formControlName="toggleButton" (change)="toggleButton()">
        <h4>Highlight the differences between the selected plans</h4>
    </mat-slide-toggle>
</form>